import axios from "../plugins/axios";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

export const searchEmails = async (caseId, searchText) => {
    let response = await axios.post(`${apiUrl}/search/searchemails`, {
        caseId,
        searchText
    });

    return response.data;
};
